import { Span, Text } from '@/components/atoms'
import { type ClaimCardTone, useClaimCard } from './claim-card.hook'

export type { ClaimCardTone }
export { getClaimToneClassName } from './claim-card.hook'

interface ClaimCardProps {
  petName: string
  petPictureUrl?: string
  claimNumber?: string
  statusLabel: string
  statusTone?: ClaimCardTone
  amount?: string
  date?: string
  message?: string
  onClick?: () => void
  className?: string
}

export function ClaimCard({
  petName,
  petPictureUrl,
  claimNumber,
  statusLabel,
  statusTone = 'info',
  amount,
  date,
  message,
  onClick,
  className = '',
}: ClaimCardProps) {
  const { petImageUrl, statusClassName, subtitle } = useClaimCard({
    petPictureUrl,
    statusTone,
    claimNumber,
    date,
  })

  return (
    <button
      type="button"
      onClick={onClick}
      className={`flex w-full flex-col gap-3 rounded-2xl border border-neutral-100 bg-white p-5 text-left transition hover:border-indigo-300 hover:shadow-[0_1px_4.25px_#8885ff] ${className}`}
    >
      <div className="flex w-full items-center gap-4">
        <img
          src={petImageUrl}
          alt=""
          className="size-14 shrink-0 rounded-full bg-indigo-50 object-cover"
        />

        <div className="flex min-w-0 flex-1 flex-col gap-1">
          <div className="flex items-baseline justify-between gap-3">
            <Text className="truncate text-lg! font-bold text-neutral-900">
              {petName}
            </Text>
            {amount && (
              <Text className="text-indigo-base shrink-0 text-lg! font-bold">
                {amount}
              </Text>
            )}
          </div>
          <div className="flex flex-wrap items-center justify-between gap-2">
            {subtitle && <Span className="text-neutral-600">{subtitle}</Span>}
            <Span
              className={`tracking-base ml-auto rounded-full px-2.5 py-0.5 text-xs! ${statusClassName}`}
            >
              {statusLabel}
            </Span>
          </div>
        </div>
      </div>

      {message && (
        <Span className="w-full rounded-lg bg-neutral-50 px-3 py-2 text-neutral-600">
          {message}
        </Span>
      )}
    </button>
  )
}
